/**
 * Obstetric Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    obstParameterPrenatalConsultation: {},
    obstetricParameter: {},
    obstetricParameters: []
};

// Getters
const getters = {
    obstetricParameter: state => {
        return state.obstetricParameter
    },

    obstParameterPrenatalConsultation: state => {
        return state.obstParameterPrenatalConsultation
    },

    obstetricParameters:state=>{
        return state.obstParameterPrenatalConsultation.parametres_obstetrique
    }
};

// Actions
const actions = {
    getObstetricParameter(context, payload) {
        function successCallback(response) {
            context.commit('getObstetricParameterHandler', { obstetricParameter: response.data.parametreObs });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Obstetric.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getObstParameterPrenatalConsultation(context, payload) {
        function successCallback(response) {
            context.commit('getObstParameterPrenatalConsultationHandler', { obstParameterPrenatalConsultation: response.data.consultationPrenatale });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Prenatal.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createObstetricParameter(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'parameter-obstetric', params: { consultation: response.data.parametreObs.consultation_prenatale.slug,parametreObstetrique: response.data.parametreObs.slug } });

            // router.push({ name: 'parameters-obstetric',params:{ consultation:response.data.parametreObs.consultation_prenatale.slug} });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Obstetric.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateObstetricParameter(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'parameters-obstetric' });

            router.push({ name: 'parameters-obstetric' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Obstetric.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteObstetricParameter(context, payload) {
        function successCallback(response) {
            context.commit('deleteObstetricParameterHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Obstetric.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getObstetricParameterHandler(state, { obstetricParameter }) {
        // Update obstParameterPrenatalConsultations state
        state.obstetricParameter = obstetricParameter;
    },

    getObstParameterPrenatalConsultationHandler(state, { obstParameterPrenatalConsultation }) {
        // Update obstParameterPrenatalConsultation state
        state.obstParameterPrenatalConsultation = obstParameterPrenatalConsultation;
        state.obstetricParameters = obstParameterPrenatalConsultation.parametres_obstetrique;
    },

    deleteObstetricParameterHandler(state, { index, successMessage }) {
        let i = state.obstetricParameters.findIndex(obstetricParameter => obstetricParameter.slug === index);

        if (~i) {

            state.obstetricParameters.splice(i, 1);

            router.push({ name: 'parameters-obstetric',params:{ consultation: state.obstParameterPrenatalConsultation.slug} });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}